import styled from "styled-components";

import Logo from "@/components/Logo";
import { Paragraph } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

export const Figure = styled.figure`
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    margin: 0;
`;

export const LogoStyled = styled(Logo)`
    align-self: flex-start;
`;

export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const HeroImg = styled.img`
    width: 300px;
    height: 300px;
    object-fit: contain;

    @media ${breakpoints.xs} {
        width: 200px;
        height: 200px;
    }
`;

export const ResultText = styled(Paragraph)`
    white-space: pre-line;
`;
